import { render, staticRenderFns } from "./contentCourseCreateSection.vue?vue&type=template&id=482b26d4&"
import script from "./contentCourseCreateSection.vue?vue&type=script&lang=js&"
export * from "./contentCourseCreateSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports